import { useMemo } from 'react';
import { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material';

export const usePlansStyles = () => {
  const theme: Theme = useTheme();

  return useMemo(
    () => ({
      logoContainer: {
        height: '80px',
      },
      headerContainer: {
        display: 'flex',
        flexDirection: 'row',
        padding: `${theme.sizeGuide['2xl']} ${theme.sizeGuide['8xl']}`,
        justifyContent: 'space-between',
      },
      root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      },
      button: {
        width: 'fit-content !important',
        margin: '0 auto',
        height: theme.sizeGuide['4xl'],
      },
      errorTitleContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.sizeGuide['4xl'],
        flexDirection: 'column',
      },
      errorSubtitleContainer: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        maxWidth: '512px',
      },
      errorContentContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.sizeGuide['4xl'],
      },
    }),
    [theme],
  );
};
